import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'antd';
import { ChromeOutlined, DownloadOutlined } from '@ant-design/icons';

/**
 * Optional workflow tools. This step only exists at all when the device probes
 * say at least one is installable (see getWalkthroughSteps), so `tools` is never
 * both-false in practice.
 */
const ToolsStep = ({
  tools, chromeExtensionInstalled, onInstallChrome, onInstallPrinter,
}) => (
  <div className="walkthrough-compact-step">
    <h2>Add Medsender to your workflow</h2>
    <p>Optional tools can help you send documents to Medsender without extra file handling.</p>
    <div className="walkthrough-tools">
      {tools.chromeExtension && (
        <Card size="small">
          <h3>Chrome extension</h3>
          <p>Send documents from supported browser-based workflows without downloading and re-uploading them.</p>
          {chromeExtensionInstalled
            ? <span className="walkthrough-tool-status">Chrome extension installed</span>
            : <Button type="primary" icon={<ChromeOutlined />} onClick={onInstallChrome}>Install Chrome extension</Button>}
        </Card>
      )}
      {tools.printerDriver && (
        <Card size="small">
          <h3>Printer driver</h3>
          <p>Add Medsender as a printer so you can send documents from desktop applications. Available for Windows and Mac.</p>
          <Button type="primary" icon={<DownloadOutlined />} onClick={onInstallPrinter}>Install printer driver</Button>
        </Card>
      )}
    </div>
  </div>
);

ToolsStep.defaultProps = {
  tools: {},
  chromeExtensionInstalled: false,
};

ToolsStep.propTypes = {
  tools: PropTypes.shape({
    chromeExtension: PropTypes.bool,
    printerDriver: PropTypes.bool,
  }),
  chromeExtensionInstalled: PropTypes.bool,
  onInstallChrome: PropTypes.func.isRequired,
  onInstallPrinter: PropTypes.func.isRequired,
};

export default ToolsStep;
